import { useState, useEffect } from "react";
import { DatePicker, message, ConfigProvider, Spin } from "antd";
import dayjs from "dayjs";
import useUserStore from "../../../stores/store";
import { isDate1GreaterThanDate2 } from "../../../utils/Common";
import { PrinterOutlined } from "@ant-design/icons";
import CustomLoader from "../../menu/CustomLoader";
import ApiService from "../../../utils/ApiService";

export default function DashboardReportPrint({ }) {
  const { showNotification, setNetworkCall, user, restaurantId } = useUserStore();
  const [fromDateTime, setFromDateTime] = useState("");
  const [toDateTime, setToDateTime] = useState("");
  const [printDataLoading, setPrintDataLoading] = useState(false);

  function onHandleFromDate(date, dateString) {
    if (isDate1GreaterThanDate2(dateString, toDateTime)) {
      showNotification("From Date time cannot be greater than To Date time.");
      return;
    }

    setFromDateTime(dateString);
  }

  function onHandleToDate(date, dateString) {
    if (dateString === "") return;
    if (date) {
      const selectedTime = date.format("HH:mm:ss");
      const timeToSet = selectedTime === "00:00:00" ? "23:59:59" : selectedTime;
      const tempToDate = date.format(`YYYY-MM-DD ${timeToSet}`);

      if (fromDateTime != "" && !(new Date(tempToDate) >= new Date(fromDateTime))) {
        message.warning("This date must be grater than from date.");
        setToDateTime(null);
        return;
      }
      setToDateTime(tempToDate);
    } else {
      setToDateTime(null);
    }
  }

  async function getSalesSummaryPrintData(payload) {
    setPrintDataLoading(true);
    try {
      const res = await ApiService.SALES_SUMMARY_PRINT(payload, user.token.token);
      if (res.code !== 200) {
        showNotification(res.message);
        return;
      }
      showNotification(res.message, false);
      return res.payload;
    } catch (err) {
      showNotification(err.response.message || "Something went wrong. Please try again later!");
    } finally {
      setPrintDataLoading(false);
    }
  }

  const handleSummaryPrint = async () => {
    if (!Boolean(fromDateTime) || !Boolean(toDateTime)) {
      showNotification('Please add from date and to date!');
      return;
    }
    const payload = {
      restaurantId,
      fromDateTime,
      toDateTime
    }
    const printData = await getSalesSummaryPrintData(payload);
    console.log('---printData-----', printData);
  };

  return (
    <section>
      <CustomLoader />
      {/* filters */}
      <ConfigProvider
        theme={{
          components: {
            DatePicker: {
              zIndexPopup: 1,
            },
          },
        }}
      >
        <div className="flex items-center space-x-[10px] w-full">
          <div className="h-[48px] ">
            <DatePicker
              className={"h-full w-full"}
              showTime={{ format: "HH:mm", showSecond: false }}
              format="YYYY-MM-DD HH:mm"
              onChange={onHandleFromDate}
              placeholder="From Date / Time"
              needConfirm
              value={fromDateTime ? dayjs(fromDateTime) : null}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>
          <div className="h-[48px] ">
            <DatePicker
              className={"h-full w-full"}
              showTime={{ format: "HH:mm", showSecond: false }}
              format="YYYY-MM-DD HH:mm"
              onChange={onHandleToDate}
              placeholder="To Date / Time"
              needConfirm
              value={toDateTime ? dayjs(toDateTime) : null}
              disabledDate={(current) => {
                if (!fromDateTime) {
                  return current && current > dayjs().endOf("day");
                }
                return (current && current < dayjs(fromDateTime).startOf("day")) || current > dayjs().endOf("day");
              }}
            />
          </div>
          <div className="h-[48px] w-[100px]">
            <button
              className="w-full h-full bg-[#FCBD10] text-[14px] font-bold text-black rounded-[5px]"
              onClick={handleSummaryPrint}
            >
              {
                printDataLoading ? <Spin size="small" /> : <PrinterOutlined className="text-lg" />
              }
            </button>
          </div>
        </div>
      </ConfigProvider>
    </section>
  );
}
